"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ThemeProvider = require("../../ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var StiloForm = function StiloForm(_ref) {
  var classes = _ref.classes,
      id = _ref.id,
      onSubmit = _ref.onSubmit,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["classes", "id", "onSubmit", "children"]);
  return /*#__PURE__*/_react["default"].createElement("form", (0, _extends2["default"])({
    className: classes.Form,
    id: id,
    onSubmit: onSubmit
  }, props), children);
};

StiloForm.propTypes = {
  id: _propTypes["default"].string,
  onSubmit: _propTypes["default"].func,
  children: _propTypes["default"].node,
  classes: _propTypes["default"].object
};
var ThemedStiloForm = (0, _ThemeProvider.withStyles)(_style["default"])(StiloForm);
var _default = ThemedStiloForm;
exports["default"] = _default;
//# sourceMappingURL=bootstrap.js.map